export enum CardFilterType {
	BY_CARD = 'BY_CARD',
	BY_SELLER = 'BY_SELLER',
}

export type CardStatus = 'ACTIVE' | 'INACTIVE';

export type MerchantCardSavedCard = {
	type: string;
	cardId: string;
	savedOn: number;
	lastFourDigits: string;
	bankName: string;
	cardStatus: CardStatus;
	cardLogoUrl: string;
	cardType: string;
	cardNetwork: string;
};

export interface IMerchantCardData {
	merchantId: string;
	merchantName: string;
	savedCards: MerchantCardSavedCard[];
}

export type CardMerchantSavedCard = {
	type: string;
	cardId: string;
	savedOn: number;
	cardStatus: CardStatus;
	merchantId: string;
	merchantName: string;
};

export interface ICardMerchantData {
	bankName: string;
	lastFourDigits: string;
	cardLogoUrl: string;
	cardType: string;
	cardNetwork: string;
	savedCards: CardMerchantSavedCard[];
}

export interface ICardListResponse {
	merchantCardData: IMerchantCardData[];
	cardMerchantData: ICardMerchantData[];
}

export enum CardDeleteStatus {
	UNSET = 'UNSET',
	INPROGRESS = 'INPROGRESS',
	SUCCESS = 'SUCCESS',
	FAILURE = 'FAILURE',
}

export interface IUserSummaryPayload {
	userId: string;
	validateState: boolean;
	fullVpa: boolean;
	org: string;
	userStateRequired: boolean;
	excludedBlacklisted: boolean;
}

export interface IUserSummaryDetails {
	blacklisted: boolean;
	deviceFingerprint: string;
	firstPartyMerchant: boolean;
	identityEmail: string;
	kycType: string;
	languagePreference: string;
	mcc: string;
	merchantType: string;
	name: string;
	phoneNumber: string;
	registrationDate: number;
	termsAccepted: boolean;
	userId: string;
	userState: string;
	userType: string;
	walletId: string;
}
